// extracted by mini-css-extract-plugin
export default {"contentWrapper":"_1wFIRb","container":"_5KzBBY","content":"awyMYM","image":"_3toCWm"};